<template>
    <div>
      <h2>Reset Password</h2>
  
      
  
      <!-- Form to reset the password -->
      <div>
        <form @submit.prevent="passwordReset">
          
          <div>
            <label for="password">New Password:</label>
            <input type="password" v-model="form.password" required minlength="8" />
          </div>
          <div>
            <label for="password_confirmation">Confirm New Password:</label>
            <input type="password" v-model="form.password_confirmation" required minlength="8" />
          </div>
          <button type="submit" @click="passwordReset()">Reset Password</button>
        </form>
      </div>
    </div>
  </template>

<script>

//import KTCard from "@/view/content/Card.vue";
import { PASSWORD_RESET } from "@/core/services/store/password_reset.module";

export default {
    name: "my-tickets-form",
    
    data() {
        return {
            form: {},
            
        };
    },
   
    methods: {
        passwordReset() {
            const data = this.form;
            const goBack = true;
            this.$store.dispatch(PASSWORD_RESET, {data, goBack})
        },

    },


    components: {
        //KTCard,
        //Multiselect
    },

    created() {
        
        
    },

    mounted() {
       
    },

    
};
</script>

